<div class="modal-dialog-wrapper">
  <div class="title-wrapper">
    <button (click)="close()">
      <mat-icon class="close-icon"> close </mat-icon>
    </button>
  </div>
  <div class="modal-pick-color">
    <span
      [style.background]="color"
      [cpToggle]="true"
      [cpDialogDisplay]="'inline'"
      [cpCancelButton]="false"
      [(colorPicker)]="color"
      class="pick-color-custom"
    ></span>
  </div>
  <div class="footer-wrapper">
    <button data-testid="dialogSecondaryButton" class="secondary-button" mat-dialog-close (click)="close()">
      Cancel
    </button>
    <button data-testid="dialogPrimaryButton" class="primary-button" mat-dialog-close (click)="pickColor()">Ok</button>
  </div>
</div>
